import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button, Tag, Typography } from "@bookips/sds";
import Link from "next/link";
const StepCard = (param)=>{
    let { step , title , body , buttonText , buttonUrl , onButtonClick , className  } = param;
    // Step에 따른 배경색 설정
    const bgColorClass = {
        step1: "bg-indigo-0",
        step2: "bg-indigo-50",
        step3: "bg-indigo-100",
        step4: "bg-indigo-200",
        step5: "bg-indigo-300"
    }[step];
    const { isMobile  } = useWindowDimensions();
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex flex-1 shrink-0 flex-col items-center justify-between rounded-md p-4", "h-[252px] max-h-[252px] w-full", "max-lg:w-[224px] max-lg:flex-none max-sm:h-[200px] max-sm:w-[180px]", bgColorClass, className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center gap-3 max-sm:gap-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "",
                        children: /*#__PURE__*/ _jsx(Tag, {
                            color: "indigo",
                            size: "md",
                            className: "typo-subtitle2 max-sm:size-sm max-sm:typo-label bg-white uppercase",
                            children: step
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h5",
                        className: "text-strong max-sm:typo-h6 w-full overflow-hidden text-center text-ellipsis",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-strong max-sm:typo-caption w-full overflow-hidden text-center text-ellipsis",
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: buttonUrl,
                onClick: onButtonClick,
                className: "w-full",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "stroke",
                    color: "secondary",
                    size: isMobile ? "sm" : "md",
                    className: "w-full shadow-sm",
                    children: buttonText
                })
            })
        ]
    });
};
export default StepCard;
